<template>
  <div
    class="
      tw-flex
      tw-items-center
      tw-px-1.5
      tw-py-1.5
      tw-bg-sf-ai-subtle-1
      tw-rounded-lg
      tw-gap-2
      tw-ml-4
    "
  >
    <span>{{ copy.actionsExplain }}</span>

    <SfButtonDs
      variant="secondary"
      size="sm"
      :disabled="finalizing"
      data-testid="reject-process-button"
      @click="emit('reject')"
    >
      {{ copy.rejectButton }}
    </SfButtonDs>
    <SfButtonDs
      variant="ai"
      size="sm"
      :disabled="finalizing"
      class="tw-bg-sf-ai-light-2"
      data-testid="accept-process-button"
      @click="emit('accept')"
    >
      {{ copy.acceptButton }}
    </SfButtonDs>
  </div>
</template>
<script setup lang="ts">
import useI18n from '@app/shared/vue/composables/use-I18n'
import { SfButtonDs } from '@silverfin/ui-components'

interface Props {
  finalizing: boolean
}

defineProps<Props>()

const emit =
  defineEmits<{
    accept: []
    reject: []
  }>()

const I18n = useI18n()
const copy = {
  actionsExplain: I18n.t(
    'client_meetings.past.meeting_proposal.actions_explain'
  ),
  rejectButton: I18n.t('client_meetings.past.meeting_proposal.reject_button'),
  acceptButton: I18n.t('client_meetings.past.meeting_proposal.accept_button'),
}
</script>
